var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@creditas-ui/system';
export var scrollBar = _ref => {
  var {
    theme: {
      dropdown
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &::-webkit-scrollbar {\n    width: 4px;\n    position: absolute;\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background: ", ";\n  }\n\n  &::-webkit-scrollbar-track {\n    margin: 10px 0;\n  }\n"])), dropdown('options.scrollbar.backgroundColor'));
};
//# sourceMappingURL=scrollbar.js.map